export enum EdgeType {
    Type = 'type',
    IamImpact = 'IamImpact',
    NetworkAccess = 'networkAccess',
    Category = 'category',
    NetworkImpact = 'networkImpact',
}

export const NODES_EDGE_TYPES = [EdgeType.Type, EdgeType.IamImpact];
